import type { Api } from '@/typings/api';
import { get, post, request } from '../request';

/**
 * 手机密码登录
 *
 * @param userName User name
 * @param password Password
 * @param rememberMe
 * @param customer 企业ID
 */
// eslint-disable-next-line max-params
export function fetchLogin(userName: string, password: string, rememberMe: boolean, customer?: string) {
  return post<Api.Auth.UserInfo>('/auth/login', {
    phone: userName,
    password,
    rememberMe,
    customer
  });
}

/**
 * 企业微信登录
 *
 * @param code Code
 */
export function fetchWxCpLogin(code: string) {
  return get<Api.Auth.UserInfo>('/auth/loginByWxCpCode', {
    code
  });
}

/**
 * 根据手机号查询用户所属客户信息
 *
 * @param phone 手机号
 * @returns 客户信息
 */
export function fetchBelongCustomers(phone: string) {
  return get<Api.Auth.CustomerInfo[]>('/auth/getBelongCustomers', {
    phone
  });
}

/** Get user info */
export function fetchGetUserInfo() {
  return get<Api.Auth.UserInfo>('/auth/getUserInfo');
}

/** 退出登录 */
export function fetchLogout() {
  return get('/auth/logout');
}

/**
 * return custom backend error
 *
 * @param code error code
 * @param msg error message
 */
export function fetchCustomBackendError(code: string, msg: string) {
  return request({ url: '/auth/error', params: { code, msg } });
}
